<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Verificar Disponibilidade', 'link' : '/' }]"
    />

    <div class="row print-no-show">
      <div class="col-6">
        <span class="mb-2 fw-bold">Verificar Disponibilidade</span>
      </div>
      <div class="col-6 text-end">
        <button @click="imprimir()" class="btn btn-sm btn-secondary"><i class="bi bi-printer me-2"></i>Imprimir</button>
      </div>
    </div>
    <hr class="print-no-show mt-0"/>

    <div class="row justify-content-center">
      <div class="col-12 col-lg-8">
        <div class="card border-0 shadow-sm">
          <div class="card-body p-4">
            <form @submit.prevent="verificar" @keydown.enter.prevent>

              <div v-if="errors.length > 0" class="alert alert-danger d-flex align-items-start mb-4" role="alert">
                <i class="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
                <ul class="mb-0 ps-3">
                  <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
              </div>

              <div class="mb-4">
                <label for="selectItem" class="form-label fw-semibold">
                  <i class="bi bi-box-seam me-1 text-primary"></i> Item
                </label>
                <select required id="selectItem" v-model="itemSelect.id_item" class="form-select form-select-lg" aria-label="Selecionar item">
                  <option disabled :value="null">Selecione um item</option>
                  <option v-for="item in listaItens" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </div>

              <div class="row g-3 mb-4">
                <div class="col-12 col-sm-6">
                  <label for="startDate" class="form-label fw-semibold">
                    <i class="bi bi-calendar-event me-1 text-primary"></i> Data de Início
                  </label>
                  <input type="date" class="form-control form-control-lg" id="startDate" v-model="itemSelect.rental_date_start">
                </div>
                <div class="col-12 col-sm-6">
                  <label for="endDate" class="form-label fw-semibold">
                    <i class="bi bi-calendar-check me-1 text-primary"></i> Data Final
                  </label>
                  <input type="date" class="form-control form-control-lg" id="endDate" v-model="itemSelect.rental_date_end">
                </div>
              </div>

              <div class="d-flex justify-content-end pt-2 border-top">
                <button type="submit" class="btn btn-primary btn-lg px-4 mt-3">
                  <i class="bi bi-search me-2"></i>Verificar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div v-if="resultado.available_quantity !== null" class="row justify-content-center mt-4">
      <div class="col-12 col-lg-8">

        <div class="row g-3 mb-4">
          <div class="col-6">
            <div class="stat-card stat-available">
              <i class="bi bi-check-circle-fill stat-icon"></i>
              <div>
                <div class="stat-value">{{ resultado.available_quantity }}</div>
                <div class="stat-label">Disponível</div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="stat-card stat-in-use">
              <i class="bi bi-hourglass-split stat-icon"></i>
              <div>
                <div class="stat-value">{{ resultado.in_use }}</div>
                <div class="stat-label">Em Uso</div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="resultado.rentals.length > 0">
          <h6 class="fw-bold text-muted mb-3 text-uppercase small">
            <i class="bi bi-list-ul me-1"></i>Aluguéis nesse período
          </h6>
          <div class="accordion" id="accordionRentals">
            <div v-for="rental in resultado.rentals" :key="rental.id" class="accordion-item mb-2">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#collapse-${rental.id}`"
                  aria-expanded="false"
                  :aria-controls="`collapse-${rental.id}`"
                >
                  <span class="d-flex justify-content-between align-items-center w-100 me-3">
                    <span>
                      <strong>#{{ rental.id }}</strong>
                      <span class="text-muted"> — {{ dateFormat.date(rental.rental_date_start) }} a {{ dateFormat.date(rental.rental_date_end) }}</span>
                    </span>
                    <span class="badge" :class="`badge-${statusColorClass(rental.status)}`">
                      {{ statusFormat.status(rental.status) }}
                    </span>
                  </span>
                </button>
              </h2>
              <div
                :id="`collapse-${rental.id}`"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionRentals"
              >
                <div class="accordion-body">
                  <div class="row">
                    <div class="col-6 col-md-4 mb-3">
                      <div class="detail-label">Período</div>
                      <div class="detail-value">{{ dateFormat.date(rental.rental_date_start) }} até {{ dateFormat.date(rental.rental_date_end) }}</div>
                    </div>
                    <div class="col-6 col-md-4 mb-3">
                      <div class="detail-label">Status</div>
                      <div class="detail-value">{{ statusFormat.status(rental.status) }}</div>
                    </div>
                    <div class="col-6 col-md-4 mb-3">
                      <div class="detail-label">Valor</div>
                      <div class="detail-value">{{ formatCurrency(rental.final_amount) }}</div>
                    </div>
                    <div class="col-6 col-md-4 mb-3">
                      <div class="detail-label">Tipo</div>
                      <div class="detail-value">{{ rental.withdrawal ? 'Retirada' : 'Entrega' }}</div>
                    </div>
                    <div v-if="rental.delivery_date" class="col-6 col-md-4 mb-3">
                      <div class="detail-label">Data de entrega</div>
                      <div class="detail-value">{{ dateFormat.dateTime(rental.delivery_date) }}</div>
                    </div>
                    <div v-if="rental.pickup_date" class="col-6 col-md-4 mb-3">
                      <div class="detail-label">Data de retirada</div>
                      <div class="detail-value">{{ dateFormat.dateTime(rental.pickup_date) }}</div>
                    </div>
                    <div v-if="rental.city" class="col-6 col-md-4 mb-3">
                      <div class="detail-label">Cidade</div>
                      <div class="detail-value">{{ rental.city }}</div>
                    </div>
                  </div>
                  <div class="mt-2">
                    <router-link :to="`/rental/details?id=${rental.id}`" class="btn btn-sm btn-outline-primary">
                      Ver detalhes <i class="bi bi-arrow-right ms-1"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="resultado.rentals.length === 0" class="text-center text-muted py-4">
          <i class="bi bi-calendar-x fs-2 d-block mb-2"></i>
          Nenhum aluguel encontrado nesse período.
        </div>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive, ref } from 'vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { itens } from '@/models/itens';
import statusFormat from '@/services/statusFormat';
import dateFormat from '@/services/dateFormat';
import { statusColorClass } from '@/utils/statusColor';

export default {
  name: "AvailableQuantitiesView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const model = itens();

    var listaItens = ref([]);
    var errors = ref([]);

    var itemSelect = reactive({
      id_item: null,
      rental_date_start: null,
      rental_date_end: null
    });

    var resultado = reactive({
      available_quantity: null,
      rentals: [],
      in_use: null
    });

    function formatCurrency(value) {
      return (value / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      // ajuste a divisão por 100 se final_amount já vier em reais, não em centavos
    }

    async function refreshItens() {
      listaItens.value = await model.list();
    }

    function validate() {
      errors.value = [];
      var current = true;
      if (!itemSelect.id_item) {
        errors.value.push('Por favor, selecione um item.');
        current = false;
      }
      if (!itemSelect.rental_date_start) {
        errors.value.push('Por favor, preencha a data de início do aluguel.');
        current = false;
      }
      if (!itemSelect.rental_date_end) {
        errors.value.push('Por favor, preencha a data de término do aluguel.');
        current = false;
      }
      return current;
    }

    function verificar() {
      errors.value = [];

      if (!validate()) { return; }

      model.checkDisponibility(
        itemSelect.id_item,
        `${itemSelect.rental_date_start}T00:00:00`,
        `${itemSelect.rental_date_end}T23:59:59`
      )
      .then(response => {
        resultado.available_quantity = response.available;
        resultado.rentals = response.rentals;
        resultado.in_use = response.in_use;
      })
      .catch(error => {
        console.error('Erro ao verificar disponibilidade:', error);
        errors.value.push('Erro ao verificar disponibilidade. Tente novamente.');
      });
    }

    function imprimir() {
      window.print();
    }

    onMounted(() => {
      refreshItens();
    });

    return {
      imprimir,
      listaItens,
      itemSelect,
      resultado,
      verificar,
      errors,
      statusFormat,
      dateFormat,
      statusColorClass,
      formatCurrency
    }
  }
}
</script>

<style scoped>

  .header-print {
    display: none;
  }

  .card {
    border-radius: 12px;
  }

  .form-label i {
    font-size: 0.95rem;
  }

  /* Stat cards */
  .stat-card {
    display: flex;
    align-items: center;
    gap: 0.9rem;
    padding: 1.1rem 1.25rem;
    border-radius: 12px;
    height: 100%;
  }

  .stat-icon {
    font-size: 1.6rem;
  }

  .stat-value {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.1;
  }

  .stat-label {
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    opacity: 0.85;
  }

  .stat-available {
    background: linear-gradient(135deg, #E7F7F0, #D3F1E4);
    color: #1D9E75;
  }

  .stat-in-use {
    background: linear-gradient(135deg, #FDF1E2, #FCE7CB);
    color: #BA7517;
  }

  /* Accordion */
  .accordion-item {
    border-radius: 10px !important;
    overflow: hidden;
    border: 1px solid #eee !important;
  }

  .accordion-button {
    font-size: 0.95rem;
  }

  .accordion-button:not(.collapsed) {
    background-color: #f8f9fb;
    box-shadow: none;
  }

  .accordion-button:focus {
    box-shadow: none;
    border-color: #eee;
  }

  .detail-label {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #8a8a8a;
    margin-bottom: 0.15rem;
  }

  .detail-value {
    font-size: 0.95rem;
    font-weight: 500;
  }

  .badge {
    color: #fff;
    font-weight: 500;
  }

  /* Valores vêm das variáveis --status-color-* em assets/main.scss
     (mesma paleta usada em Route/StopCard.vue, para não duplicar). */
  .badge-pending-delivery       { background: linear-gradient(90deg, var(--status-color-pending-delivery), var(--status-color-pending-delivery-light)); }
  .badge-pending-pickup         { background: linear-gradient(90deg, var(--status-color-pending-pickup), var(--status-color-pending-pickup-light)); }
  .badge-active                 { background: linear-gradient(90deg, var(--status-color-active), var(--status-color-active-light)); }
  .badge-pending-company-pickup { background: linear-gradient(90deg, var(--status-color-pending-company-pickup), var(--status-color-pending-company-pickup-light)); }
  .badge-pending-return         { background: linear-gradient(90deg, var(--status-color-pending-return), var(--status-color-pending-return-light)); }
  .badge-completed              { background: linear-gradient(90deg, var(--status-color-completed), var(--status-color-completed-light)); }
  .badge-scheduled              { background: linear-gradient(90deg, var(--status-color-scheduled), var(--status-color-scheduled-light)); }
  .badge-unknown                { background: linear-gradient(90deg, var(--status-color-unknown), var(--status-color-unknown-light)); }

  @media print {
    /* Esconde tudo no corpo */
    body * {
      visibility: hidden;
    }

    .print-no-show {
      display: none !important;
    }

    .header-print {
      display: block;
      margin-bottom: 20px;
      margin-top: -10px;
    }

    /* Mostra apenas a div de impressão */
    #conteudoParaImprimir, #conteudoParaImprimir * {
      visibility: visible;
    }

    /* Opcional: Forçar quebra de página */
    #conteudoParaImprimir p {
      page-break-inside: avoid;
    }
  }

</style>